export default __webpack_public_path__ + "static/2-72d25b347b421903e1475e47377fdc5e.jpg";